<div class="page-loader text-center load-more link-wrapper fullwidth" *ngIf="loadButton">
	<span><span class="loading__circle loading__circle-small"></span></span>
</div>
<div class="news__detail-page" [class.page-loading]='loadButton' *ngIf="!error_message_show">
	<section id="breadcrumb" class="breadcrumb bg-color-white text-color-dark">
		<div class="wrapper">
			<div class="breadcrumb__text">
				<strong class="home-page"><a href="./">WWW</a> / </strong> 
				<span class="current-page">News</span>			
			</div>
		</div>
	</section>
	<section id="page-intro" class="component component--page-intro page-intro bg-color-white text-color-dark">
		<div class="wrapper">
			<div class="page-intro__text">
				<small class="news__cat" *ngIf="'' != news_detail?.news_category">{{ news_detail?.news_category }} . {{ news_detail?.news_date }}</small>
				<small class="news__cat" *ngIf="'' == news_detail?.news_category" [innerHtml]="news_detail?.news_date"></small>
				<h1 class="page-title" *ngIf="news_detail?.title != ''" [innerHtml]="news_detail?.title"></h1>
				<div class="preamble" *ngIf="news_detail?.excerpt != ''" [innerHtml]="news_detail?.excerpt | safe:'preamble'"></div>
			</div>
		</div>
	</section>
	<section class="component component--content">
		<div class="wrapper">
			<div class="row">
				<div class="col-12 col-md-9">
					<div class="content_wrapper">
						<div class="figure-type out_of_boundary">
							<figure id="out_of_boundary" class="image-type out_of_boundary" *ngIf="news_detail?.image && news_detail?.news_category != 'Video'">
								<img [defaultImage]="isMobile ? news_detail?.mobile_image : news_detail?.image" [lazyLoad]="isMobile ? news_detail?.mobile_image : news_detail?.image" alt="{{ news_detail?.title }}" class="img-responsive" loading="lazy" [width]="isMobile ? '767' : '1192'" />
								<p *ngIf="news_detail?.image_caption != ''" [innerHtml]="news_detail?.image_caption | safe:'preamble'" class="img-caption"></p>
							</figure>
							<div class="resources__repeater resources__video" *ngIf="news_detail?.news_video != '' && news_detail?.news_category == 'Video'">
								<div class="embed-responsive embed-responsive-16by9">
									<iframe width="560" height="315" [src]="video_url" frameborder="0"></iframe>
								</div>
							</div>
						</div>
						<div class="page-intro" *ngIf="news_detail?.excerpt != ''">
							<div class="preamble" [innerHtml]="news_detail?.excerpt | safe:'preamble'"></div>
						</div>
						<div class="entry-content" *ngIf="news_detail?.detail != ''" [innerHtml]="news_detail?.detail | safe:'preamble'"></div>
					</div>
				</div>
				<div class="col-12 col-md-3" *ngIf="news_detail?.side_link?.url">
					<div class="content__sidebar">
						<a href="{{ news_detail?.side_link?.url }}" class="news__link" target="{{ news_detail?.side_link?.target }}">
							<figure *ngIf="news_detail?.side_image != ''">
								<img src="{{ news_detail?.side_image?.url }}" alt="{{ news_detail?.side_image?.title }}" class="img-responsive" loading="lazy" />
								<p *ngIf="news_detail?.side_image?.caption != ''" [innerHtml]="news_detail?.side_image?.caption | safe:'preamble'" class="img-caption"></p>
							</figure>
							<div class="besides-figure entry-content" *ngIf="news_detail?.side_heading != '' || news_detail?.side_content != '' || news_detail?.side_link?.url != ''">
								<h4 *ngIf="news_detail?.side_heading != ''" [innerHtml]="news_detail?.side_heading"></h4>
								<div *ngIf="news_detail?.side_content != ''" [innerHtml]="news_detail?.side_content | safe:'preamble'"></div>
								<p class="btn-wrapper" *ngIf="news_detail?.side_link != ''"><span class="link-span btn btn-bluelight btn-circle"><span>{{ news_detail?.side_link?.title }}</span> <i class="icon-arrow-right"></i></span></p>
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
<div class="component-holder bg-color-white text-color-dark" [ngClass]="loadButton?'page-loading':''"  *ngIf="!error_message_show">
	<div class="app-component-repeater" *ngFor="let val of news_result;let i = index" [ngClass]="val.acf_fc_layout == 'blurb_block' ? 'has-tab-sibling': ''" >
		<app-newsblurb *ngIf="val.acf_fc_layout == 'blurb_block'" [newsBlurbContent]="val.inner_blurb" [newsBlurbColor]="val.news_blurb_block_color"></app-newsblurb>
		<app-newsdoublecontent *ngIf="val.acf_fc_layout == 'double_content_column'" [newsDoubleColContent]="val"></app-newsdoublecontent>
		<app-newsfile *ngIf="val.acf_fc_layout == 'file_block'" [newsFileContent]="val"></app-newsfile>
		<app-newswpengage *ngIf="val.acf_fc_layout == 'wp_engage_block'" [newsWpEngageContent]="val"></app-newswpengage>
		<app-newsimagevideo *ngIf="val.acf_fc_layout == 'imagevideo_block'" [newsImageVideoContent]="val"></app-newsimagevideo>
		<app-newscontent *ngIf="val.acf_fc_layout == 'simple_content_block'" [newsContent]="val"></app-newscontent>
	</div>
</div>
<div class="alert-login error-message" id="error-message" *ngIf="error_message_show">
	<div class="wrapper">
		<span><p [innerHtml]="error_message"></p></span>
	</div>
</div>